/* eslint-disable */
<template>
  <div class="upcoming-bookings">
    <Navigation indexProps="2" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Upcoming Bookings</h1></div>
        <div class="header-sub-title">Manage bookings and upload documentation for an upcoming appointment.</div>
      </div>
    </div>
    <div class="panel">
      <ClientBookingMenu indexProps="1" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <el-input style="max-width: 115px" class="mr-1" @input="search()" clearable placeholder="Booking ID" v-model="listParam.BookingID"/>
            <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Examinee Name" v-model="listParam.ClaimantName"/>
            <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Specialist Name" v-model="listParam.SpecialistName"/>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col-2 pl-0">
              <div class="border-image ml-0">
                <div class="border-image-number">{{totalCount}}</div>
                <div class="border-image-text">Upcoming</div>
              </div>
            </div>
            <div class="col">&nbsp;</div>
            <div class="col">&nbsp;</div>
          </div>
          <div class="table-responsive">
            <el-table @row-click="RowClick" ref="bookingTable" :default-sort="{prop: 'BookingDateTime', order: 'ascending'}" stripe @sort-change="sortParam" :data="upcomingBookings" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
              <el-table-column
                  width="100"
                  prop="BookingID"
                  label="ID"
                  sortable="custom"
                  show-overflow-tooltip
                  fixed="left"
              >
              </el-table-column>
              <el-table-column
                  width="150"
                  sortable="custom"
                  show-overflow-tooltip
                  label="Examinee"
                  prop="ClaimantFullName"
              >
                <template slot-scope="booking">
                  <span>{{ decodeURIComponent(booking.row.Case.ClaimantFullName)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="BookingDateTime"
                  sortable="custom"
                  label="Appointment"
              >
                <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.BookingDateTime, "DD/MM/YYYY HH:mm", "YYYY-MM-DD HH:mm:ss.ssssss")
                      }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="Specialist"
                  label="Specialist"
                  sortable="custom"
              >
                <template slot-scope="booking">
                  <span>{{booking.row.Specialist && decodeURIComponent(booking.row.Specialist.Title + ' ' + booking.row.Specialist.FirstName + ' ' + booking.row.Specialist.Surname)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  prop="location"
                  width="250"
                  label="Location"
                  sortable="custom"
              >
                <template slot-scope="booking">
                  <span>{{ booking.row.Location && decodeURIComponent(booking.row.Location.LocationName)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  width="250"
                  prop="BookingType"
                  label="Service Type"
                  sortable="custom"
              >
                <template slot-scope="booking">
                  <span>{{ decodeURIComponent(booking.row.BookingType.BookingTypeName)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  width="250"
                  prop="DeliveryMethodID"
                  label="Delivery Method"
              >
                <template slot-scope="scope">
                   <span v-if="scope.row.DeliveryMethodID">{{
                       scope.row.DeliveryMethodID === 1 ? 'In-person' : 'Virtual'
                     }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="user.type >= 2"
                  width="150"
                  show-overflow-tooltip
                  sortable="custom"
                  prop="ClientContact"
                  label="Client Contact">
                <template slot-scope="booking">
                  <span>{{booking.row.ClientContact && decodeURIComponent(booking.row.ClientContact.FirstName + ' ' + booking.row.ClientContact.MiddleName + ' ' + booking.row.ClientContact.Surname)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="100"
                  sortable="custom"
                  show-overflow-tooltip
                  prop="BookingStatus"
                  label="Booking Status"
              >
                <template slot-scope="booking">
                  <span>{{ booking.row.Status.StatusDescription }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="PaperworkDue"
                  label="Paperwork Due"
                  sortable="custom"
              >
                <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.PaperworkDue, 'DD/MM/YYYY') }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="200"
                  show-overflow-tooltip
                  prop="ClaimantConfirmed"
                  label="Examinee Confirmed?"
              >
                <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.ClaimantConfirmed, 'DD/MM/YYYY') }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="totalCount > listParam.pageSize" class="pagination">
            Page
            <div class="pagination-group">
              <div class="border-icon pagination-current dropdown">
                <div class="pagination-current-text">{{ listParam.pageNum }}</div>
                <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                  <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
          </div>
        </div>
      </div>
    </div>
    <Chat />
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import Navigation from '@/components/Navigation'
import ClientBookingMenu from '@/components/ClientBookingMenu'
import Header from '@/components/Header'
import { debounce } from 'lodash';
import Chat from '@/components/Chat'

export default {
  name: 'UpcomingBookings',
  components: {
    Navigation,
    ClientBookingMenu,
    Header,
    Chat,
  },
  data() {
    return {
      limit: 12,
      pagination: utilities.initPagination(),
      byDate: false,
      byPaperwork: false,
      byPaperworkDue: false,
      maxDate: '',
      upcomingBookings: [],
      allUpcomingBookings: [],
      totalCount: 0,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'BookingDateTime',
        ascOrDesc: 'ASC',
        BookingDateTimeFrom: window.moment().format('YYYY-MM-DD'),
        SpecialistName: '',
        ClaimantName: '',
        BookingID: null,
        Status: '3,4,7,9,10',
      },
      paperworkStatuses: utilities.getPaperworkStatuses(),
      searchBookingId: '',
      searchClaimantName: '',
      searchSpecialist: '',
    }
  },

  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },

  methods: {
    sortParam( v ) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },
    RowClick(row) {
      this.editBooking(row?.BookingID)
    },
    getBookingStatus(id) {
      return utilities.getBookingStatus(id)
    },
    search: debounce(function () {
      this.selectPage(1)
    }, 800),

    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },

    formatDate(date, dateToFormat, newFormat)  {
      return utilities.formatDate(date, dateToFormat, newFormat);
    },

    editBooking(bookingId) {
      this.$router.push({path:'/edit-booking', query:{id:bookingId}}).catch((err) => {})
    },

    async loadData() {
      await this.$store.dispatch("loading/setLoadComponent", true)
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      let {bookings, total} = await utilities.getAllBookingsNew(obj);
      this.upcomingBookings = bookings
      this.totalCount = total
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
  },

  async beforeMount() {
    await this.loadData()
    this.$store.dispatch("loading/setLoadComponent", false)
  },

  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  },
}
</script>
